<template>
    <div class="content-wrap ques ">
        <div class="content-top-wrap count-down">
            <!-- <i class="icon icon-clock"/> -->
            <div class="clock">
                <div class="con1">
                    <div class="pie1" :style="`transform: rotate(${leftTime >= 15 ? (30 - leftTime) * 12 : 180}deg)`"></div>
                </div>
                <div class="con2">
                    <div class="pie2" :style="`transform: rotate(${leftTime >= 15 ? 0 : (15 - leftTime) * 12}deg)`"></div>
                </div>
            </div>
            <CountDown
                ref="countDown"
                @finish="() => handleAns('countDown', true)"
                @change="handleTime"
                :time="30 * 1000"
                format="ss"
            />
        </div>
        <div class="scroll-content middle" ref="content">
            <QueItem
                :question="questions[index]"
                :val.sync="answers[questions[index].quiz_id]">
                <span v-if="questions.length" slot="queIndex">
                    {{index + 1}}/{{questions.length}}
                </span>
            </QueItem>
        </div>
        <div class="cac-btn custom-btn" :disabled="!canNext" @click="handleAns">{{questions.length - 1 > index ? '下一题' : '提交'}}</div>
        <img src="http://guokrapp-static.guokr.com/FmG51Y2z5yeQqJd-kW-WuF-ZoYpE" alt="" class="p2">
    </div>
</template>

<script>
import { CountDown } from 'vant';
import QueItem from '@/components/Question';
import { throttle } from '@/utils/func'
export default {
    name: 'ques',
    props: ['questions'],
    components: {
        CountDown,
        QueItem,
    },
    watch: {
        index () {
            this.$refs.countDown.reset()
            this.$refs.countDown.start()
            this.$refs.content.scrollTop = 0
        },
    },
    computed: {
        canNext: function () {
            return this.answers[this.questions[this.index].quiz_id]
        }
    },
    data() {
        return {
            index: 0,
            answers:{},
            leftTime: 30,
        };
    },
    mounted() {
    },
    methods: {
        handleAns: throttle(function (type = '', skip = false) {
            if (!this.canNext && !skip) return
            if (!this.answers[this.questions[this.index].quiz_id] ) {
                this.answers[this.questions[this.index].quiz_id] = {
                    seq_id: 0,
                    score: this.questions[this.index].score
                }
            }

            // 超时已选不积分
            if (type === 'countDown') {
                this.answers[this.questions[this.index].quiz_id] = {
                    seq_id: 0,
                    score: this.questions[this.index].score
                }
            }

            if (this.questions.length > Object.keys(this.answers).length) {
                this.index ++
            } else {
                this.$emit('submit', this.answers)
            }
        }, 200),
        handleTime (time) {
            this.leftTime = time.seconds
        }
    }
};
</script>
<style lang="less" scoped>
.ques {
    .btn{
        margin: auto;
    }
    .clock {
        position: relative;
        background: #fff;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
        margin-right: 5px;
        [class^=pie], [class^=con] {
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
        }
        .con1 {
            clip: rect(0rem, 2rem, 2rem, 1rem);
            position: absolute;
            .pie1 {
                clip: rect(0rem, 2rem, 2rem, 1rem);
                position: absolute;
                background: #BBD2F9;
            }
        }
        .con2 {
            clip: rect(0rem, 1rem, 2rem, 0rem);
            position: absolute;
            .pie2 {
                clip: rect(0rem, 1rem, 2rem, 0rem);
                position: absolute;
                background: #BBD2F9;
            }
        }
    }
    .count-down {
        display: flex;
        justify-content: flex-end;
        margin: 1rem 0.3rem;
        position: absolute;
        top: 0;
        right: 0;
        /deep/.van-count-down, .icon {
            display: inline-block;
            color: #fff;
            font-size: 1.3rem;
            font-weight: bold;
            line-height: 2.1rem;
        }
        /deep/.van-count-down {
            width: 2rem;
            text-align: center;
        }
        .icon {
            margin-right: .5rem;
            font-size: 2.1rem;
        }
    }
    .scroll-content {
        flex: 1;
        margin: 4.1rem auto 15px;
        background-image: url(http://guokrapp-static.guokr.com/FjdVsfpZ3JKyhZK7H5-zCRAGeryD);
        background-size: calc(100% + 27%) calc(100% + 25%);
        background-position: 50%;
        background-repeat: no-repeat;
        padding: 0;
        width: 90%;
        border: 10vw solid transparent;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        .question-item {
            /deep/p, /deep/span {
                color: #3F3F3F;
            }
            /deep/.radio-icon-round {
                border: 1px solid #3F3F3F;
                &.active::before {
                    color: #3D4FA5;
                }
            }
        }
    }
    .custom-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 18rem;
        height: 6rem;
        margin: 30px auto 80px;
        background-image: url(http://guokrapp-static.guokr.com/Fi5s1UGozCHLUCLeWyT7Ru3BXEp4);
        background-size: 100% 100%;
        text-align: center;
        font-size: 17px;
        color: #3f3f3f;
        font-weight: bolder;
        text-align: center;
        &[disabled] {
            background-image: url(http://guokrapp-static.guokr.com/Fuis2ckUKAGJFuaGp5sIkCHf5oME);
            color: #f3f3f3;
        }
    }
}
</style>
